


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setGetTagManager,
  updateSeoTagManager,
} from "../../../redux/seo/action";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { seoTagManager } from "../../Constant/constant";

const SeoTopManager = () => {
  const id = 1;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const seoHome = useSelector((state) => state?.reusableSlice?.seoTagmanager);

  useEffect(() => {
    if (id) {
      dispatch(setGetTagManager(id));
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      body: seoHome?.body || "",
      header: seoHome?.header || "",
      title: seoHome?.title || "",
      id: seoHome?.id || "",
    },

    validationSchema: seoTagManager,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
      };
      dispatch(updateSeoTagManager(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };
  return (
    <div className="px-4 pb-3 pt-5">
      <div className=" category-wrapper">
      <h1>Tag Manager</h1>

      <form onSubmit={formik.handleSubmit}>
      <div className="col-md-12  description-add">
      <div className="row">
        <div className="col-md-6 form-group">
          <label>Body</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter body"
            name="body"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.body}
          />
          {formik.touched.body && formik.errors.body ? (
            <div className="error">{formik.errors.body}</div>
          ) : null}
        </div>
        <div className="col-md-6 form-group">
          <label>Header</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter header"
            name="header"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.header}
          />
          {formik.touched.header && formik.errors.header ? (
            <div className="error">{formik.errors.header}</div>
          ) : null}
        </div>
        <div className="col-md-6 form-group">
          <label>Title</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter title"
            name="title"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.title}
          />
          {formik.touched.title && formik.errors.title ? (
            <div className="error">{formik.errors.title}</div>
          ) : null}
        </div>
      
        <div
          className="d-flex align-items-center justify-content-center  w-100  "
          style={{ columnGap: "20px" }}
        >
          <button
            className="submit-btn   "
            style={{ width: "max-content" }}
            type="submit"
          >
            {!loading ? "Update" : <Spinner />}
          </button>
        </div>
        </div>
        </div>

      </form>
      </div>
    </div>
  );
};

export default SeoTopManager;

